export enum SpecStatisticsSurface {
  Talents = 'talents',
  Gear = 'gear',
  Trinkets = 'trinkets'
}

export enum SpecStatisticsActivity {
  MythicPlus = 'mythic-plus',
  Raid = 'raid'
}
